@use '~/theme/theme' as *;
@use '~/theme/typography';

.valueContainer {
  font-family: 'Public Sans', sans-serif;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--background-color);
  color: var(--color);
  display: flex;
  align-items: center;
  width: 100%;
  cursor: var(--cursor);
  gap: spacing(1);

  &[data-hovered='true'] {
    --border-color: #{color(violet-600)};
  }
}

.optionWithBorderBottom {
  border-bottom: border(grey-300, sm);
}

.selectField {
  --border-color: #{color(grey-600)};
  --background-color: white;
  --color: #{color(grey-800)};
  --cursor: pointer;
  --action-icon-size: 24px;

  &[data-focused] .valueContainer {
    outline: none;
  }

  &[data-focus-visible] .valueContainer {
    --border-color: #{color(violet-600)};
  }

  &[data-open] .valueContainer {
    --border-color: #{color(violet-600)};

    outline: 1px solid var(--border-color);
  }

  &[data-invalid] {
    --border-color: #{color(lobster-800)};
  }

  &[data-disabled] {
    --background-color: #{color(grey-100)};
    --border-color: #{color(grey-400)};
    --color: #{color(grey-500)};
    --cursor: default;
  }
}

.media {
  overflow: hidden;
}

.value {
  flex-grow: 1;
  text-align-last: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &[data-placeholder='true'] {
    color: color(grey-600);
  }
}

.clear {
  position: absolute;
  right: calc(12px + 2px + var(--action-icon-size));
  top: 50%;
  transform: translateY(-50%);
}

.fakeClear {
  visibility: hidden;
  margin-right: 2px;
  width: var(--action-icon-size);
}

.triggerContainer {
  position: relative;
}

.selectField[data-size='small'] {
  --action-icon-size: 24px;

  .valueContainer {
    @include typography.caption;
    @include typography.medium;

    height: 32px;
    padding: spacing(0.75) spacing(1.5);

    .icon {
      @include icon-size(sm);
    }

    .media {
      max-height: 24px;
      max-width: 24px;
    }

    .selectedDisplayLabel {
      display: block;
    }
  }

  .chevron,
  .clear {
    height: var(--action-icon-size);
    width: var(--action-icon-size);
    padding: 2px;
  }
}

.selectField[data-size='medium'] {
  --action-icon-size: 24px;

  .valueContainer {
    @include typography.body2;
    @include typography.regular;

    height: 38px;
    padding: spacing(1) spacing(1.5);

    .icon {
      @include icon-size(sm);
    }

    .media {
      max-height: 24px;
      max-width: 24px;
    }

    .selectedDisplayLabel {
      display: block;
    }
  }

  .chevron,
  .clear {
    height: var(--action-icon-size);
    width: var(--action-icon-size);
    padding: 2px;
  }
}

.selectField[data-size='large'] {
  --action-icon-size: 32px;

  .valueContainer {
    @include typography.body1;
    @include typography.regular;

    height: 48px;
    padding: spacing(1.5);

    .icon {
      @include icon-size(md);
    }

    .media {
      max-height: 32px;
      max-width: 32px;
    }

    .selectedDisplayLabel {
      display: block;
    }
  }

  .chevron,
  .clear {
    height: var(--action-icon-size);
    width: var(--action-icon-size);
  }
}

.multiselectTrigger {
  &[data-focused] {
    outline: none;
  }

  &[data-focus-visible] {
    --border-color: #{color(violet-600)};
  }
}
